export const presskitAcceptByType = {
  image: "image/jpeg,image/png,image/webp",
  video: "video/mp4,video/webm",
};
